const categories = [
  { id: 1, name: 'Продукты', class: 'four-section' },
  { id: 2, name: 'Хоз.товары', class: 'third-section' },
  { id: 3, name: 'Напитки', class: 'six-section' },
  { id: 4, name: 'Пиво', class: 'seven-section' },
  { id: 5, name: 'Горячее', class: 'eight-section' },
  { id: 6, name: 'Готовое', class: 'five-section' },
  { id: 7, name: 'Мороженое', class: 'second-section' },
  { id: 8, name: 'Сувенир', class: 'nine-section' },
  { id: 9, name: 'Под заказ', class: 'first-section' },
]

export default categories